import { useState } from "react";

const ITEMS = [
  { id: "c1", label: "域名主体与官方完全一致，无混入的数字、符号或前后缀" },
  { id: "c2", label: "地址栏显示安全锁，全程为加密的 https 链接" },
  { id: "c3", label: "页脚公示的运营主体与备案号经官方系统核验真实存在" },
  { id: "c4", label: "访问入口来自官方网址、应用商店或可信搜索结果" },
  { id: "c5", label: "页面栏目完整、内容连续，无错别字与残缺模块" },
  { id: "c6", label: "未要求提供银行卡、身份证照片或短信验证码等敏感信息" },
  { id: "c7", label: "未诱导下载来历不明的安装包，也未要求私下转账" },
  { id: "c8", label: "拿不准时，已通过官方客服渠道做了二次核实" },
];

export default function Checklist() {
  const [checked, setChecked] = useState<Record<string, boolean>>({});
  const done = ITEMS.filter((it) => checked[it.id]).length;
  const percent = Math.round((done / ITEMS.length) * 100);
  const safe = done >= 7;

  const toggle = (id: string) => setChecked((prev) => ({ ...prev, [id]: !prev[id] }));
  const reset = () => setChecked({});

  return (
    <section id="checklist" className="scroll-mt-20 bg-background-100/60">
      <div className="wrap py-10 md:py-14">
        <div className="grid gap-8 lg:grid-cols-[1fr_0.92fr] lg:items-center">
          <div className="order-2 lg:order-1">
            <div className="relative overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20flat%20vector%20illustration%20of%20a%20clipboard%20checklist%20with%20a%20large%20green%20checkmark%20and%20a%20small%20broken%20padlock%20aside%2C%20web%20security%20verification%20theme%2C%20warm%20cream%20background%2C%20vermilion%20red%20amber%20and%20forest%20green%20palette%2C%20minimal%20clean%20vector%20art%2C%20no%20text&width=700&height=620&seq=checklist-art&orientation=landscape"
                alt="用于网站真伪核验的自查清单示意插画"
                className="h-60 w-full object-cover lg:h-[420px]"
                width={700}
                height={620}
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="kicker mb-3">
              <i className="ri-task-line"></i>
              交互式自查清单
            </p>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">访问前花一分钟，逐项打勾确认</h2>
            <p className="mt-3 text-[15px] leading-7 text-foreground-700">
              把下面的判断标准当作临门一脚：全部满足才算相对安全，任一项不满足就先别继续。你随时可以点击条目打勾并复位重做。
            </p>

            <div className="mt-5 flex items-center gap-3">
              <div className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
                <div
                  className="h-full rounded-full bg-secondary-500 transition-all duration-500"
                  style={{ width: `${percent}%` }}
                ></div>
              </div>
              <span className="text-sm font-semibold text-secondary-700 whitespace-nowrap">{percent}%</span>
            </div>

            <ul className="mt-4 space-y-2">
              {ITEMS.map((it) => {
                const on = !!checked[it.id];
                return (
                  <li key={it.id}>
                    <button
                      type="button"
                      onClick={() => toggle(it.id)}
                      className="flex w-full cursor-pointer items-start gap-3 rounded-md border border-background-200 bg-background-50 p-3 text-left transition-colors hover:border-secondary-300"
                      aria-pressed={on}
                    >
                      <span
                        className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded border text-xs transition-colors ${
                          on
                            ? "border-secondary-500 bg-secondary-500 text-background-50"
                            : "border-background-300 text-transparent"
                        }`}
                      >
                        <i className="ri-check-line"></i>
                      </span>
                      <span
                        className={`text-sm leading-6 ${
                          on ? "text-foreground-500 line-through" : "text-foreground-800"
                        }`}
                      >
                        {it.label}
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div
                className={`flex items-center gap-2 text-sm font-semibold ${
                  safe ? "text-secondary-700" : "text-primary-700"
                }`}
              >
                <i className={safe ? "ri-shield-check-line text-lg" : "ri-error-warning-line text-lg"}></i>
                {safe ? "恭喜，这些信号基本指向正规站点。" : "尚有存疑项，建议先回到官方渠道核实。"}
              </div>
              <button
                type="button"
                onClick={reset}
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:text-foreground-950"
              >
                <i className="ri-restart-line"></i>
                重新开始
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}